import { render } from "./AudioModal.vue?vue&type=template&id=c85c6b06&scoped=true&ts=true"
import script from "./AudioModal.vue?vue&type=script&lang=ts"
export * from "./AudioModal.vue?vue&type=script&lang=ts"

import "./AudioModal.vue?vue&type=style&index=0&id=c85c6b06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85c6b06"]])

export default __exports__